import http from '@/shared/api/http'

export async function getAllAttributes() {
  const response = await http.get('/attributes')
  return response.data
}

export async function createAttribute(data) {
  const response = await http.post('/attributes', data)
  return response.data
}

export async function updateAttribute(id, data) {
  const response = await http.put(`/attributes/${id}`, data)
  return response.data
}

export async function deleteAttribute(id) {
  const response = await http.delete(`/attributes/${id}`)
  return response.data
}

export async function getAttributeById(id) {
  const response = await http.get(`/attributes/${id}`)
  return response.data
}

export async function getAttributesByType(productTypeId) {
  const response = await http.get(`/attributes/by-type/${productTypeId}`)
  return response.data
}